import React, { useEffect, useState } from "react";
import { Box, Typography, TextField, Button, Grid } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";

import { fetchItType, updateItType } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";

export default function ItTypeEditPage() {
  const { businessDomainId, itTypeId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  const [form, setForm] = useState({ itTypeName: "", itTypeDescription: "" });
  const [fullData, setFullData] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const d = await fetchItType(itTypeId);
        setFullData(d);
        setForm({
          itTypeName: d.itTypeName || "",
          itTypeDescription: d.itTypeDescription || "",
        });
      } catch (e) { notify.apiError(e); }
    })();
  }, [itTypeId]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = { ...fullData, ...form };
      await updateItType(payload);
      notify.success(t("message.update.success"));
      navigate(`/design/${businessDomainId}/it-types/${itTypeId}`);
    } catch (err) { notify.apiError(err); }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>{t("itType.edit.title")}</Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid size={12}>
            <TextField fullWidth required multiline label={t("itType.name")}
              name="itTypeName" value={form.itTypeName} onChange={handleChange} />
          </Grid>
          <Grid size={12}>
            <TextField fullWidth multiline rows={3} label={t("itType.description")}
              name="itTypeDescription" value={form.itTypeDescription} onChange={handleChange} />
          </Grid>
        </Grid>
        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit">{t("common.save")}</Button>
          <Button variant="outlined" onClick={() => navigate(`/design/${businessDomainId}/it-types/${itTypeId}`)}>{t("common.cancel")}</Button>
        </Box>
      </Box>
    </Box>
  );
}
